window.onload = function () {};

var map;
var markers = [];
var infoWindow;
var styles = [
    {
        featureType: "all",
        elementType: "labels.text.fill",
        stylers: [
            {
                color: "#ffffff",
            },
        ],
    },
    {
        featureType: "all",
        elementType: "labels.text.stroke",
        stylers: [
            {
                color: "#000000",
            },
            {
                lightness: 13,
            },
        ],
    },
    {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [
            {
                color: "#000000",
            },
        ],
    },
    {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [
            {
                color: "#144b53",
            },
            {
                lightness: 14,
            },
            {
                weight: 1.4,
            },
        ],
    },
    {
        featureType: "landscape",
        elementType: "all",
        stylers: [
            {
                color: "#08304b",
            },
        ],
    },
    {
        featureType: "poi",
        elementType: "geometry",
        stylers: [
            {
                color: "#0c4152",
            },
            {
                lightness: 5,
            },
        ],
    },
    {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [
            {
                color: "#000000",
            },
        ],
    },
    {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [
            {
                color: "#0b434f",
            },
            {
                lightness: 25,
            },
        ],
    },
    {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [
            {
                color: "#000000",
            },
        ],
    },
    {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [
            {
                color: "#0b3d51",
            },
            {
                lightness: 16,
            },
        ],
    },
    {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [
            {
                color: "#000000",
            },
        ],
    },
    {
        featureType: "transit",
        elementType: "all",
        stylers: [
            {
                color: "#146474",
            },
        ],
    },
    {
        featureType: "water",
        elementType: "all",
        stylers: [
            {
                color: "#021019",
            },
        ],
    },
];
setTimeout(() => {
  let zipInput = document.getElementById("zip-code-input");
  if (null != zipInput) {
      zipInput.value = "";
  }  
}, 750);
    if (!document.querySelectorAll(`[src="https://maps.googleapis.com/maps/api/js"]`).length) {
        document.body.appendChild(
            Object.assign(document.createElement("script"), {
                type: "text/javascript",
                src: "https://maps.googleapis.com/maps/api/js?key=AIzaSyA9znlzxt_YVNFH8J857uFoGCam0V75ADA",
                onload: () => {
                    initMap();
                },
            })
        );
    } else {
        initMap();
    }


function initMap() {
    setTimeout(() => {
      var losAngeles = {
          lat: 34.06338,
          lng: -118.35808,
      };
      var mapsEl = document.getElementById("map");
            console.log("mapsEl", mapsEl);
      if (null != mapsEl) {
        map = new google.maps.Map(mapsEl, {
            center: losAngeles,
            zoom: 13,
            mapTypeId: "roadmap",
            styles: styles,
            gestureHandling: "none",
            mapTypeControl: false,
        });
        infoWindow = new google.maps.InfoWindow();
        searchStores();
      }
   }, 1000);
}

function searchStores() {
    
    var foundStores = [];
    var zipCode = document.getElementById("zip-code-input").value;
    if (zipCode) {
        for (var store of stores) {
            var postal = String(store["address"]["postalCode"]).substring(0, 5);
            if (postal == zipCode) {
                foundStores.push(store);
            }
        }
        console.log("stores", foundStores);
        if (foundStores.length === 0) {
            var losAngeles = {
                lat: 34.06338,
                lng: -118.35808,
            };
            map.setCenter(new google.maps.LatLng(34.06338, -118.35808));
        }
    } else {
        foundStores = stores;
    }
    clearLocations();
    if (foundStores.length > 0) {
        displayStores(foundStores);
        showStoresMarkers(foundStores);
        setOnClickListener();
        map.setZoom(13);
    }
}

function clearLocations() {
    infoWindow.close();
    for (var i = 0; i < markers.length; i++) {
        markers[i].setMap(null);
    }
    markers.length = 0;
}

function setOnClickListener() {
    var storeElements = document.querySelectorAll(".store-container");
    storeElements.forEach(function (element, index) {
        element.addEventListener("click", function () {
            new google.maps.event.trigger(markers[index], "click");
        });
    });
}

function displayStores(stores) {
    console.log("displayStores", stores);
    var storesHtml = "";
    for (var [index, store] of stores.entries()) {
        var name = store["name"];
        var address = store["addressLines"];
        var phone = store["phoneNumber"];
        var url = store["url"];
        if (null != url && url.trim() !== "") {
            storesHtml += `
            <div class="store-container">
              <div class="store-container-background">
                <div class="store-info-container">
 				  <div class="store-info-name">
                    ${name}
                  </div>
                  <div class="store-address">
                    <span>${address[0]}</span>
          			<span>${address[1]}</span>
                  </div>
                  <a href="${url}" target="blank"><div class="store-phone-number">Weedmaps Menu</div></a>
                </div>
              </div>
            </div>`;
        } else {
            storesHtml += `
            <div class="store-container">
              <div class="store-container-background">
                <div class="store-info-container">
 				  <div class="store-info-name">
                    ${name}
                  </div>
                  <div class="store-address">
                    <span>${address[0]}</span>
          			<span>${address[1]}</span>
                  </div>
                </div>
              </div>
            </div>`;
        }
        document.getElementById("stores-list").innerHTML = storesHtml;
    }
}

function showStoresMarkers(stores) {
    var bounds = new google.maps.LatLngBounds();
    for (var [index, store] of stores.entries()) {
        var latlng = new google.maps.LatLng(store["coordinates"]["latitude"], store["coordinates"]["longitude"]);
        var name = store["name"];
        var address = store["addressLines"][0];
        var openStatusText = store["openStatusText"];
        var url = store["url"];
        bounds.extend(latlng);
        createMarker(latlng, name, address, url, index + 1);
    }
    map.fitBounds(bounds);
}

function createMarker(latlng, name, address, url, index) {
    var html = `
      <div class="store-info-window">
        <div class="store-info-name">
          ${name}
        </div>
        <div class="store-info-address">
          <div class="circle">
            <i class="fas fa-location-arrow"></i>
          </div>
          ${address}
        </div>
        
      </div>
  `;
    if (null != url && url.trim() !== "") {
        html = `
		<div class="store-info-window">
          <div class="store-info-name">
            ${name}
          </div>
          <div class="store-info-address">
            <div class="circle">
              <i class="fas fa-location-arrow"></i>
            </div>
            ${address}
          </div>
          <a href="${url}" target="blank"><div class="store-info-phone">
            <div class="circle">
              <i class="fas fa-link"></i>
            </div>
            Weedmaps Menu
			</a>
		</div>`;
    }
    const svgMarker = {
        path: "M10.453 14.016l6.563-6.609-1.406-1.406-5.156 5.203-2.063-2.109-1.406 1.406zM12 2.016q2.906 0 4.945 2.039t2.039 4.945q0 1.453-0.727 3.328t-1.758 3.516-2.039 3.070-1.711 2.273l-0.75 0.797q-0.281-0.328-0.75-0.867t-1.688-2.156-2.133-3.141-1.664-3.445-0.75-3.375q0-2.906 2.039-4.945t4.945-2.039z",
        fillColor: "#512179",
        fillOpacity: 1,
        strokeWeight: 0,
        rotation: 0,
        scale: 4,
        anchor: new google.maps.Point(15, 30),
    };

    var pinColor = "512179";
    var pinImage = new google.maps.MarkerImage("http://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|" + pinColor, new google.maps.Size(42, 68), new google.maps.Point(0, 0), new google.maps.Point(10, 34));
    var pinShadow = new google.maps.MarkerImage("http://chart.apis.google.com/chart?chst=d_map_pin_shadow", new google.maps.Size(40, 37), new google.maps.Point(0, 0), new google.maps.Point(12, 35));
    var marker = new google.maps.Marker({
        map: map,
        position: latlng,
    });
    google.maps.event.addListener(marker, "click", function () {
        infoWindow.setContent(html);
        infoWindow.open(map, marker);
    });
    markers.push(marker);
}
